<template>
  <!----------- TASK REMINDER --------------->
  <div class="notifications card text-md" id="tpl_taskReminder_popup">
    <div class="cursor-pointer absolute right-5 hover:text-[var(--color-orange)]" id="btn_close">
      <i @click.prevent="deactivate()">
        <font-awesome-icon icon="fa-xmark"/>
      </i>
    </div>
    <div class="text-justify p-5">
      <div class="flex">
        <h3>
          <span id="tpl_taskReminder_popup_firstName">
          {{ notification.content.firstName }}
          </span>
          <span id="tpl_taskReminder_popup_header">
          {{ $t('TaskReminderNotificationComponent.taskiWillExpireInfoMessage') }} </span>
          <span id="tpl_taskReminder_popup_timePeriod">
            {{ getTimeRemaining }}.
          </span>
        </h3>
      </div>
      <div class="mt-2 text-md">
        <p>
          <span id="tpl_taskReminder_popup_text">
            {{ $t('TaskReminderNotificationComponent.finishIt') + ' ' }}
          </span>
          <router-link :to="getLink"
            class="text-md font-semibold text-[var(--color-orange)]
            hover:text-[var(--color-fulvous)]"
            id="tpl_newTask_popup_link">
            {{ $t('TaskReminderNotificationComponent.rightAway') }}
          </router-link>
          .
        </p>
      </div>
      <div class="text-[var(--color-disabled)] float-right text-xs">
        <span>
          {{ $t('TaskReminderNotificationComponent.footlineOMIND') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['notification'],
  name: 'TaskReminderNotificationComponent',
  data() {
    return {
      hoursRemaining: null,
      minutesRemaining: null,
      secondsRemaining: null,
    };
  },
  computed: {
    getLink() {
      return `/questionnaire?id=${this.notification.assessment}`;
    },
    getTimeRemaining() {
      if (this.hoursRemaining > 1) {
        return `${this.hoursRemaining} ${this.$t('TaskReminderNotificationComponent.hoursPlural')}`;
      }
      if (this.hoursRemaining > 0) {
        return `${this.hoursRemaining} ${this.$t('TaskReminderNotificationComponent.hoursShort')}`;
      }
      if (this.minutesRemaining > 0) {
        return `${this.minutesRemaining} ${this.$t('TaskReminderNotificationComponent.minutesShort')}`;
      }
      return `${this.secondsRemaining} ${this.$t('TaskReminderNotificationComponent.secondsShort')}`;
    },
  },
  methods: {
    deactivate() {
      this.$store.dispatch('deactivatePopUp', this.notification._id);
    },
  },
  mounted() {
    const localDate = new Date(this.notification.date_until).getTime();
    let x;

    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = localDate - now;

      if (distance <= 0) {
        clearInterval(x);
        this.$store.dispatch('deactivatePopUp', this.notification._id);
        return;
      }

      this.hoursRemaining = Math.floor(distance / (1000 * 60 * 60));
      this.minutesRemaining = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      this.secondsRemaining = Math.floor((distance % (1000 * 60)) / 1000);
    };

    updateCountdown();

    x = setInterval(updateCountdown, 1000);
  },
};
</script>
